import Image from "next/image";
import React from "react";
import RoundStar from "@/app/assets/round-star.svg";
import TickGreen from "@/app/assets/tick-green.svg";

type ContentItem = {
  heading: string;
  description: string;
};

type FeatureType = {
  heading: string;
  description: string;
};

type TabWithTableProps = {
  feature: FeatureType;
  contents: ContentItem[];
};

export default function TabWithTable({ feature, contents }: TabWithTableProps) {
  return (
    <div className="flex flex-col lg:flex-row rounded-3xl overflow-hidden shadow-sm h-auto">
      <div className="lg:w-[40%] w-full flex flex-col">
        <div className="bg-purple px-6 py-4 md:px-8 md:py-5">
          <h3 className="text-white font-bold text-lg md:text-xl uppercase tracking-wide text-center">
            Feature
          </h3>
        </div>

        <div className="bg-gradient-to-b from-[#E0F7F6] to-[#B8F0EE] px-6 py-10 md:px-10 md:py-16 flex-1 flex flex-col justify-center">
          <div className="flex items-start gap-4 md:gap-6">
            <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-white flex items-center justify-center flex-shrink-0">
              <Image
                src={RoundStar}
                alt="Feature"
                className="w-14 h-14 md:w-16 md:h-16"
              />
            </div>

            <div>
              <h4 className="text-gray-900 font-bold text-xl md:text-2xl mb-2">
                {feature.heading}
              </h4>
              <p className="text-gray-600 text-base md:text-lg leading-relaxed">
                {feature.description}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="lg:w-[60%] w-full">
        <div className="bg-purple px-6 py-4 md:px-8 md:py-5">
          <h3 className="text-white font-bold text-lg md:text-xl uppercase tracking-wide text-center">
            Benefits
          </h3>
        </div>
        <div className="bg-gradient-to-b from-[#E0F7F6] to-[#B8F0EE] px-6 py-8 md:px-10 md:py-10 flex-1 h-full">
          <div className="flex flex-col gap-6 md:gap-8">
            {contents?.map((content, index) => (
              <div key={index} className="flex items-start gap-4">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-[#fffff] flex items-center justify-center flex-shrink-0">
                  <Image
                    src={TickGreen}
                    alt="Benefit"
                    className="w-10 h-10 md:w-12 md:h-12"
                  />
                </div>

                <div>
                  <h5 className="text-gray-900 font-bold text-base md:text-lg mb-1">
                    {content.heading}
                  </h5>
                  <p className="text-gray-600 text-sm md:text-base leading-relaxed">
                    {content.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
